// extracted by mini-css-extract-plugin
export var contentBody = "_cz-9";
export var headerImage = "_cz-2";
export var imageButton = "_cz-7";
export var imageButtonIcon = "_cz-8";
export var imageHeader = "_cz-4";
export var imageHeaderText = "_cz-5";
export var imageOverlay = "_cz-3";
export var imageTitle = "_cz-6";
export var imageWrapper = "_cz-1";
export var taskList = "_cz-a";
export var widget = "_cz-0";